/**
 * Enum for taggable content types.
 */
enum TaggableTypes {
  CHALLENGES = 'challenges',
  PLAYLISTS = 'playlists',
  SCENARIOS = 'scenarios',
  USERS = 'users',
  TEAMS = 'teams'
};

export default TaggableTypes;